import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin")({
  head: () => ({ meta: [{ title: "Admin Panel | BAZZAR 3D" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-shell")),
});
